<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="5" fill="#299FC2"/>
<circle cx="15" cy="7" r="6" fill="#ED5270"/>
<circle cx="6.5" cy="15.5" r="5.5" fill="#37A87A"/>
</svg>
